module.exports = __webpack_public_path__ + "static/media/bestof_3.76b1b376.jpg";